<template>
  <div style="width: 100%; height: 100%; overflow: hidden; position: relative">
    <pageBottom></pageBottom>
    <!-- <img style="width: 100%; height: 100%" src="~@/assets/images/about-bg.png" /> -->
    <swiper
      class="about-swiper"
      :modules="modules"
      :loop="true"
      style="height: 100%; width: 100%"
      :slidesPerView="1"
      :pagination="pagination"
      @slideChange="onSlideChange"
      @swiper="onSwiper"
    >
      <swiper-slide>
        <visionPage></visionPage>
      </swiper-slide>
      <swiper-slide>
        <historyPage></historyPage>
      </swiper-slide>
      <swiper-slide>
        <impressionPage v-if="currentIndex == 2"></impressionPage>
      </swiper-slide>
    </swiper>
    <div class="about-pagination">
      <img
        src="~@/assets/images/about/about-block-left.png"
        class="left-block"
      />
      <img
        src="~@/assets/images/about/about-block-right.png"
        class="right-block"
      />
      <div class="line">
        <img src="~@/assets/images/about/about-pagination-line.png" />
      </div>
      <ul class="about-swiper-pagination">
        <li
          @touchstart="paginationTouch(0)"
          :class="{ check: currentIndex == 0 }"
        ></li>
        <li
          @touchstart="paginationTouch(1)"
          :class="{ check: currentIndex == 1 }"
        ></li>
        <li
          @touchstart="paginationTouch(2)"
          :class="{ check: currentIndex == 2 }"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, reactive, ref } from "vue";
import visionPage from "./briefIntro.vue";
import historyPage from "./history.vue";
import impressionPage from "./impression.vue";
import pageBottom from "../../pageBottom.vue";
import { loadGamePage, loadWorkPage } from "@/assets/js/preload";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
const modules = [Navigation, Pagination, Scrollbar, A11y, Autoplay];

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
});
onMounted(() => {
  // loadGamePage();
  // loadWorkPage();
});

const emits = defineEmits(["indexChange"]);
const currentIndex = ref(0);

const onSlideChange = (e) => {
  console.log(e);
  currentIndex.value = e.realIndex;
  emits("indexChange", currentIndex.value);
};

const swiperRef = ref({});
const onSwiper = (swiper) => {
  swiperRef.value = swiper;
  swiperRef.value.slideToLoop(props.index);
};

const pagination = reactive({
  type: "custom",
});

const paginationTouch = (index) => {
  if (index == currentIndex.value) return;
  swiperRef.value.slideToLoop(index);
};
</script>

<style lang="scss" scoped>
.about-swiper {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  .swiper-slide {
    opacity: 0;
  }
  .swiper-slide-active {
    opacity: 1;
  }
}
.about-pagination {
  position: absolute;
  left: 0;
  top: 147.4074rem;
  z-index: 3;
  width: 100%;
  height: 25.2778rem;

  .left-block {
    position: absolute;
    left: 0.5556rem;
    top: 9.3519rem;
    width: 6.6667rem;
    height: 6.3889rem;
  }
  .right-block {
    position: absolute;
    top: 0;
    right: 1.2037rem;
    width: 7.3148rem;
    height: 6.1111rem;
  }
  .line {
    position: absolute;
    top: 5.1852rem;
    left: 0;
    height: 13.0556rem;
    width: 100%;
    overflow: hidden;
    transform-style: preserve-3d;
    transform: translateZ(1px);

    img {
      position: absolute;
      bottom: 0;
      left: -90.5556rem;
      margin: auto;
      width: 281.1111rem;
      height: 282.7778rem;

      transform: translateZ(1px);

      animation: circleKeyframe 3s;
      @keyframes circleKeyframe {
        0% {
          transform: rotate(-60deg) translateZ(1px);
          opacity: 0;
        }
        100% {
          transform: translateZ(1px);
          opacity: 1;
        }
      }
    }
  }

  transform-style: preserve-3d;
  .about-swiper-pagination {
    height: 100%;
    li {
      position: absolute;
      width: 15.1852rem;
      height: 13.8889rem;

      background-repeat: no-repeat;
      background-position: 50%;
      background-size: cover;
    }
    li:nth-child(1) {
      top: 3.3333rem;
      left: 14.4444rem;
      background-image: url(~@/assets/images/about/about-pagination-1.png);

      &.check {
        top: 1.3889rem;
        left: 11.0185rem;
        width: 21.2963rem;
        height: 21.1111rem;
        background-image: url(~@/assets/images/about/about-pagination-check-1.png);
      }
    }
    li:nth-child(2) {
      top: 6.1111rem;
      left: 42.3148rem;
      background-image: url(~@/assets/images/about/about-pagination-2.png);

      &.check {
        top: 4.1667rem;
        left: 38.9815rem;
        width: 21.2963rem;
        height: 21.1111rem;
        background-image: url(~@/assets/images/about/about-pagination-check-2.png);
      }
    }
    li:nth-child(3) {
      top: 3.3333rem;
      right: 14.4444rem;
      background-image: url(~@/assets/images/about/about-pagination-3.png);

      &.check {
        top: 1.3889rem;
        right: 11.7593rem;
        width: 21.2963rem;
        height: 21.1111rem;
        background-image: url(~@/assets/images/about/about-pagination-check-3.png);
      }
    }
    transform: translateZ(2px);
    animation: callMoveKeyframe 2.6s;
    @keyframes callMoveKeyframe {
      0% {
        opacity: 0;
        transform: translate3d(-60%, 0, 2px);
      }
      100% {
        opacity: 1;
        transform: translateZ(2px);
      }
    }
  }
}
</style>